import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MarketmanagerSharedModule } from '../../shared';
import { MarketmanagerAdminModule } from '../../admin/admin.module';
import {
    MarketdateMeterreadingService,
    MarketdateMeterreadingPopupService,
    MarketdateMeterreadingComponent,
    MarketdateMeterreadingDetailComponent,
    MarketdateMeterreadingDialogComponent,
    MarketdateMeterreadingPopupComponent,
    MarketdateMeterreadingDeletePopupComponent,
    MarketdateMeterreadingDeleteDialogComponent,
    marketdateMeterreadingRoute,
    marketdateMeterreadingPopupRoute,
} from './';

const ENTITY_STATES = [
    ...marketdateMeterreadingRoute,
    ...marketdateMeterreadingPopupRoute,
];

@NgModule({
    imports: [
        MarketmanagerSharedModule,
        MarketmanagerAdminModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        MarketdateMeterreadingComponent,
        MarketdateMeterreadingDetailComponent,
        MarketdateMeterreadingDialogComponent,
        MarketdateMeterreadingDeleteDialogComponent,
        MarketdateMeterreadingPopupComponent,
        MarketdateMeterreadingDeletePopupComponent,
    ],
    entryComponents: [
        MarketdateMeterreadingComponent,
        MarketdateMeterreadingDialogComponent,
        MarketdateMeterreadingPopupComponent,
        MarketdateMeterreadingDeleteDialogComponent,
        MarketdateMeterreadingDeletePopupComponent,
    ],
    providers: [
        MarketdateMeterreadingService,
        MarketdateMeterreadingPopupService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarketmanagerMarketdateMeterreadingModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-meterreading/marketdate-meterreading.module.ts